import { render, staticRenderFns } from "./StoSlider.vue?vue&type=template&id=60ea6bb4&scoped=true&"
import script from "./StoSlider.vue?vue&type=script&lang=js&"
export * from "./StoSlider.vue?vue&type=script&lang=js&"
import style0 from "./StoSlider.vue?vue&type=style&index=0&id=60ea6bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea6bb4",
  null
  
)

export default component.exports